export const environment = {
  production: true,
  frontendUrl: 'https://hebern.com',
  apiUrl: 'https://validation.hebern.com',
  encryptionApiUrl: 'https://api.hebern.com',
  assetsBaseUrl: 'https://hebern.com',
  CANONICAL_URL: "https://hebern.com",
};
